import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ToastHostComponent } from '@movilidad/app-ui';
import { TextScaleService } from '@movilidad/app-ui/text-scale';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet, ToastHostComponent],
  template: `
    <ion-app>
      <ion-router-outlet />
      <ui-toast-host />
    </ion-app>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly textScale = inject(TextScaleService);

  ngOnInit(): void {
    this.textScale.initialize();
    if (Capacitor.isNativePlatform()) void this.prepareNative();
  }

  private async prepareNative(): Promise<void> {
    // Una falla de estos plugins deja la barra de estado por omisión, nunca el app sin arrancar.
    await StatusBar.setStyle({ style: Style.Light }).catch(() => undefined);
    await SplashScreen.hide().catch(() => undefined);
  }
}
